import React, { useContext, useEffect, useState } from "react";
import editPen from "../../Assets/frond-details/edit-pen.svg";
import rocket from "../../Assets/frond-details/rocket.svg";
import dollar from "../../Assets/frond-details/dollar.svg";
import calendar from "../../Assets/frond-details/calendar.svg";
import like from "../../Assets/frond-details/like.svg";
import { Image } from "@nextui-org/react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import EditDetailsModal from "./EditDetailsModal";
import { SettingsContext } from "Context/SettingsContext";
import useSettings from "hooks/useSettings";
import placholderIcon from "../../Assets/frond-details/placholder-icon.svg";
import editImgIcon from "../../Assets/frond-details/message-edit.svg";
import { PopUpContext } from "Context/PopUpContext";
import EditFrondImageModal from "./EditFrondImageModal";
import { CashedDataContext } from "Context/CashedDataContext";
import AIGenerateImageModal from "./AIGenerateImageModal";
import qrCode from "../../Assets/landing/goals/qr2.jpeg";
import { API_BASE_URL } from "../../config/apiConfig";

const AboutFrondDetails = ({token}) => {
  const [editDetailsModal, setEditDetailsModal] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [showAIGenerateModal, setShowAIGenerateModal] = useState(false);
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const [hasActiveSubscription, setHasActiveSubscription] = useState(false);
  const [checkingSubscription, setCheckingSubscription] = useState(false);
      const [subscriptionData, setSubscriptionData] = useState(null);
      const [generatedData, setGeneratedData] = useState(null);
      

  const [frondDetails, setFrondDetails] = useState([]);

  const { frondId } = useParams();
  let authToken = localStorage.getItem("token");

// Check subscription status
  const checkSubscription = async () => {
    if (!authToken) {
      setHasActiveSubscription(false);
      return false;
    }

    setCheckingSubscription(true);
    try {
      const response = await axios.get(
        `${API_BASE_URL}/billing/subscription-status`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            'Accept': 'application/json',
          },
        }
      );
      
      const apiData = response.data?.data;
      const hasAccess = apiData?.has_active_subscription === true;
      
      setHasActiveSubscription(hasAccess);
      return hasAccess;
    } catch (error) {
      console.error('Subscription check failed:', error);
      setHasActiveSubscription(false);
      return false;
    } finally {
      setCheckingSubscription(false);
    }
  };
  const getFrondDetails = async () => {
    setIsLoading(true);
    try {
      const { data } = await axios.get(
        `${API_BASE_URL}/frond/${frondId}`,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      setFrondDetails(data?.response?.data);
    } catch (error) {
      toast(error?.response?.data?.message, {
        autoClose: 1500,
        position: "bottom-right",
        hideProgressBar: true,
        className: "rounded-4xl custom-toast error-toast",
      });
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getFrondDetails();
  }, []);

  const { isEditLocation } = useContext(PopUpContext);

  useEffect(() => {
    if (isEditLocation) {
      getFrondDetails();
    }
  }, [isEditLocation]);

  useSettings({ projectId: frondId });
  const { frondSettings } = useContext(SettingsContext);

  const [editImagenModal, setEditImageModal] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) {
      return "-";
    }
    const separator = dateString.includes('-') ? '-' : '/';
    const parts = dateString.split(separator);
    
    let year, month, day;
    if (separator === '-') {
      [year, month, day] = parts;
    } else {
      [day, month, year] = parts;
    }
    const date = new Date(year, month - 1, day);

    if (isNaN(date.getTime())) {
      return "-"; 
    }
    const options = { year: 'numeric', month: 'short', day: '2-digit' };
    return new Intl.DateTimeFormat('en-GB', options).format(date).replace(' ', ', ');
  };

  const parseDateToArray = (dateString) => {
    if (!dateString) return null;
    const separator = dateString.includes('-') ? '-' : '/';
    const parts = dateString.split(separator);
    
    if (parts.length !== 3) return null;
    
    let year, month, day;
    if (separator === '-') {
      [year, month, day] = parts;
    } else {
      [day, month, year] = parts;
    }
    
    const parsedYear = parseInt(year, 10);
    const parsedMonth = parseInt(month, 10);
    const parsedDay = parseInt(day, 10);
    
    const date = new Date(parsedYear, parsedMonth - 1, parsedDay);
    if (isNaN(date.getTime())) return null;
    
    return [parsedDay, parsedMonth, parsedYear];
  };

  // Handle AI Image Generation button click
  const handleAIGenerateClick = async (e) => {
    e.stopPropagation();
    console.log("🎨 AI Generate button clicked");
    
    // First, check if user is owner
    if (!frondSettings.is_owner) {
      console.log("❌ User is not owner, cannot generate AI image");
      toast("Only project owner can generate AI images", {
        autoClose: 2000,
        position: "bottom-right",
        hideProgressBar: true,
        className: "rounded-4xl custom-toast error-toast",
      });
      return;
    }
    
    // Check if project already has an image
    if (frondDetails?.image) {
      console.log("❌ Project already has an image");
      toast("Project already has an image. Delete it first to generate a new one.", {
        autoClose: 2000,
        position: "bottom-right",
        hideProgressBar: true,
        className: "rounded-4xl custom-toast error-toast",
      });
      return;
    }
    
    console.log("🔍 Checking subscription status...");
    const hasSubscription = await checkSubscription();
    console.log("📊 Has subscription result:", hasSubscription);
    
    if (hasSubscription) {
      console.log("✅ Has subscription, opening AI generate modal");
      setShowAIGenerateModal(true);
    } else {
      console.log("❌ No subscription, opening subscription modal with QR code");
      setShowSubscriptionModal(true);
    }
  };

  // Check if project has an image
  const hasImage = !!frondDetails?.image;

  return (
    <>
      <section className="about-frond">
        <div className="flex gap-x-2.5 gap-y-2.5 items-start justify-between timelineMedia:flex-nowrap flex-wrap">
          <div className="flex flex-col content">
            {/* ... existing info sections ... */}
            <div className="flex items-start gap-5">
              <div className="info flex items-start phone:gap-[45px] gap-5 mb-5">
                <div className="flex flex-col gap-2">
                  <h5 className="text-cardGrayColor phone:text-sm text-[10px] leading-normal font-normal">
                    Category
                  </h5>
                  <div className="flex items-center gap-[5px]">
                    <Image
                      src={rocket}
                      alt="Rocket"
                      className="phone:min-w-[18px] phone:min-h-[18px] phone:max-w-[18px] phone:max-h-[18px] min-w-[12px] min-h-[12px] max-w-[12px] max-h-[12px]"
                    />
                    <span className="leading-normal text-textColor phone:text-base text-[10px]">
                      {frondDetails?.frond?.category || "-"}
                    </span>
                  </div>
                </div>
                <div className="flex flex-col gap-2">
                  <h5 className="text-cardGrayColor phone:text-sm text-[10px] leading-normal font-normal">
                    Importance
                  </h5>
                  <div
                    className={`${
                      !frondDetails?.frond?.priority &&
                      "text-center text-[10px]"
                    }`}
                  >
                    <span
                      className={`leading-normal ${
                        frondDetails?.frond?.priority === "High" &&
                        "text-[#FF3D00E5]"
                      } ${
                        frondDetails?.frond?.priority === "Medium" &&
                        "text-[#FFC000]"
                      } ${
                        frondDetails?.frond?.priority === "Low" &&
                        "text-[#5CCDB0]"
                      } ${!frondDetails?.frond?.priority && "text-textColor"}`}
                    >
                      {frondDetails?.frond?.priority
                        ? frondDetails?.frond?.priority
                        : "-"}
                    </span>
                  </div>
                </div>
                <div className="flex flex-col gap-2">
                  <h5 className="text-cardGrayColor phone:text-sm text-[10px] leading-normal font-normal">
                    Budget
                  </h5>
                  <div className="flex items-center gap-[5px]">
                    <Image
                      src={dollar}
                      alt="Dollar"
                      className="phone:min-w-[18px] phone:min-h-[18px] phone:max-w-[18px] phone:max-h-[18px] min-w-[12px] min-h-[12px] max-w-[12px] max-h-[12px]"
                    />
                    <span className="leading-normal text-textColor phone:text-base text-[10px]">
                      {frondDetails?.frond?.budget
                        ? frondDetails?.frond?.budget
                        : ""}
                    </span>
                    <span className="leading-normal text-textColor phone:text-base text-[10px]">
                      {frondDetails?.frond?.currency
                        ? frondDetails?.frond?.currency
                        : "$"}
                    </span>
                  </div>
                </div>
              </div>
              {frondSettings.is_owner && (
                <button onClick={() => setEditDetailsModal(true)}>
                  <Image
                    src={editPen}
                    alt="Pen"
                    className="phone:min-w-6 phone:min-h-6 phone:max-w-6 phone:max-h-6 min-w-[12px] min-h-[12px] max-w-[12px] max-h-[12px]"
                  />
                </button>
              )}
            </div>
            <div className="info flex items-start gap-[22px] mb-5">
              <div className="flex flex-col gap-2">
                <h5 className="text-cardGrayColor phone:text-sm text-[10px] leading-normal font-normal">
                  Start Date
                </h5>
                <div className="flex items-center gap-[5px]">
                  <Image
                    src={calendar}
                    alt="Calendar"
                    className="phone:min-w-[18px] phone:min-h-[18px] phone:max-w-[18px] phone:max-h-[18px] min-w-[12px] min-h-[12px] max-w-[12px] max-h-[12px]"
                  />
                 <span className="leading-normal text-textColor phone:text-base text-[10px]">
                    {formatDate(frondDetails?.frond?.start_date)}
                </span>
                </div>
              </div>
              <div className="flex flex-col gap-2">
                <h5 className="text-cardGrayColor phone:text-sm text-[10px] leading-normal font-normal">
                  End Date
                </h5>
                <div className="flex items-center gap-[5px]">
                  <Image
                    src={calendar}
                    alt="Calendar"
                    className="phone:min-w-[18px] phone:min-h-[18px] phone:max-w-[18px] phone:max-h-[18px] min-w-[12px] min-h-[12px] max-w-[12px] max-h-[12px]"
                  />
                  <span className="leading-normal text-textColor phone:text-base text-[10px]">
                    {formatDate(frondDetails?.frond?.end_date)}
                </span>
            </div>
              </div>
            </div>
            <div className="info flex items-start gap-[22px] mb-5">
              <div className="flex flex-col gap-2">
                <h5 className="text-cardGrayColor sm:text-sm text-[10px] md:text-base lg:text-lg leading-normal font-normal">
                  Description
                </h5>
                <div
                  className={`${!frondDetails?.frond?.desc && "text-center flex flex-col gap-2.5"} sm:text-sm text-[10px] md:text-base lg:text-lg`}
                >
                  <p className="leading-snug text-textColor sm:text-sm text-[10px] md:text-base lg:text-lg ">
                    {frondDetails?.frond?.desc
                      ? frondDetails?.frond?.desc
                      : "-"}
                  </p>
                </div>
              </div>
            </div>
            <div className="info flex items-start gap-[22px] mb-5">
              <div className="flex flex-col gap-2">
                <div className="flex items-center gap-[5px]">
                  <Image
                    src={like}
                    alt="Heart"
                    className="phone:min-w-[18px] phone:min-h-[18px] phone:max-w-[18px] phone:max-h-[18px] min-w-[12px] min-h-[12px] max-w-[12px] max-h-[12px]"
                  />
                  <span className="text-cardGrayColor phone:text-sm text-[10px] leading-normal font-normal">
                    Tags
                  </span>
                </div>
                <div
                  className={`flex items-center phone:text-base text-[10px] ${
                    frondDetails?.tags?.length === 0 && "justify-center"
                  } gap-2.5 flex-wrap`}
                >
                  {frondDetails?.tags?.length > 0
                    ? frondDetails?.tags.map((item, idx) => (
                        <div
                          key={idx}
                          className="py-1.5 px-2.5 rounded-[20px] bg-mainBlue text-white flex justify-center items-center"
                        >
                          <span className="phone:text-sm text-[10px] leading-[16.1px]">
                            {item.name.en}
                          </span>
                        </div>
                      ))
                    : "-"}
                </div>
              </div>
            </div>
          </div>

          {/* Updated Image Section with AI Generate Button */}
          <div className="group relative card-img w-full max-w-[500px] mx-auto md:mx-0 cursor-pointer overflow-hidden rounded-[20px]">
            <div className="w-full aspect-square overflow-hidden">
              {frondDetails?.image ? (
                <div
                  className="w-full h-full transition-transform duration-500 group-hover:scale-110"
                  style={{
                    backgroundImage: `url(${frondDetails?.image})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                  }}
                />
              ) : (
                <div className="flex flex-col justify-center items-center w-full h-full bg-gradient-to-br from-gray-100 to-gray-200">
                  <Image
                    src={placholderIcon}
                    alt="placeholder"
                    className="w-1/3 h-auto object-contain mb-4"
                  />
                  <p className="text-gray-400 text-sm">No image yet</p>
                </div>
              )}
            </div>

            {/* Hover Overlay with Buttons */}
            <div className="absolute inset-0 z-20 flex flex-col items-center justify-center gap-3
                          bg-black/60 backdrop-blur-sm
                          opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              
              {/* Edit Image Button - Always shown for owner */}
              {frondSettings.is_owner && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setEditImageModal(true);
                  }}
                  className="flex gap-2 items-center bg-white/20 px-4 py-2 rounded-full 
                           border border-white/40 shadow-lg hover:bg-white/40 transition-all"
                >
                  <Image src={editImgIcon} alt="Edit Image" className="w-5 h-5" />
                  <span className="text-white font-medium text-sm">Edit Image</span>
                </button>
              )}

              {/* AI Generate Button - ONLY SHOWN WHEN NO IMAGE EXISTS */}
              {!hasImage && frondSettings.is_owner && (
                <button
                  onClick={handleAIGenerateClick}
                  disabled={checkingSubscription}
                  className="flex gap-2 items-center bg-gradient-to-r from-pink-500 to-orange-500 
                           px-4 py-2 rounded-full border border-white/40 shadow-lg 
                           hover:from-orange-600 hover:to-pink-600 transition-all duration-300"
                >
                  <span className="text-xl">✨</span>
                  <span className="text-white font-medium text-sm">
                    {checkingSubscription ? 'Checking...' : 'Generate with Fern'}
                  </span>
                </button>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Modals */}
      {editDetailsModal && (
        <EditDetailsModal
          isOpen={editDetailsModal}
          isModalOpen={true}
          onClose={() => {
            setEditDetailsModal(false);
          }}
          getFrondData={getFrondDetails}
          frondData={{
            editId: frondDetails?.frond?.id,
            editTitle: frondDetails?.frond?.title,
            editCategory: frondDetails?.frond?.category,
            editDesc: frondDetails?.frond?.desc,
            editStartDate: parseDateToArray(frondDetails?.frond?.start_date),
            editEndDate: parseDateToArray(frondDetails?.frond?.end_date),
            editBudget: frondDetails?.frond?.budget,
            editCurrecy: frondDetails?.frond?.currency,
            editTags: frondDetails?.tags,
            editImportance: frondDetails?.frond?.priority,
            editLatitude: frondDetails?.latitude,
            editLongitude: frondDetails?.longitude,
            editCountry: frondDetails?.frond?.country,
            editCity: frondDetails?.frond?.city,
            editLocation: frondDetails?.frond?.location,
          }}
        />
      )}
      
      {editImagenModal && (
        <EditFrondImageModal
          isOpen={editImagenModal}
          onClose={() => {
            setEditImageModal(false);
          }}
          editId={frondDetails?.frond?.id}
          editTitle={frondDetails?.frond?.title}
          editCategory={frondDetails?.frond?.category}
          editImage={frondDetails?.image}
          editBudget={frondDetails?.frond?.budget}
          editCurrecy={frondDetails?.frond?.currency}
          editDesc={frondDetails?.frond?.desc}
          editStartDate={parseDateToArray(frondDetails?.frond?.start_date)}
          editEndDate={parseDateToArray(frondDetails?.frond?.end_date)}
          editImportance={frondDetails?.frond?.priority}
          editLatitude={frondDetails?.latitude}
          editLongitude={frondDetails?.longitude}
          editCountry={frondDetails?.frond?.country}
          editCity={frondDetails?.frond?.city}
          editLocation={frondDetails?.frond?.location}
          editTags={frondDetails?.tags}
          getFrondData={getFrondDetails}
        />
      )}

      {/* AI Generate Image Modal */}
      {showAIGenerateModal && (
        <AIGenerateImageModal
          isOpen={showAIGenerateModal}
          onClose={() => {
            setShowAIGenerateModal(false);
          }}
          projectId={frondId}
          projectTitle={frondDetails?.frond?.title}
          projectCategory={frondDetails?.frond?.category}
          projectLocation={frondDetails?.frond?.location}
          onImageGenerated={() => {
            getFrondDetails(); // Refresh the page to show new image
          }}
        />
      )}

      {/* Subscription Required Modal with QR Code - Same style as AICreateProject */}
      {showSubscriptionModal && (
        <div className="fixed inset-0 mt-10 bg-black/60 backdrop-blur-sm flex justify-center items-center z-50 animate-fadeIn">
          <div className="bg-white rounded-4xl max-w-xl w-[90%] overflow-hidden shadow-2xl animate-slideUp">
            {/* Modal Header */}
            <div className="bg-gradient-to-r from-orange-500 to-pink-500 px-6 py-4">
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center backdrop-blur-sm">
                    <span className="text-xl">📱</span>
                  </div>
                  <h3 className="text-xl font-bold text-white">
                    Subscription Required
                  </h3>
                </div>
                <button 
                  className="text-white/80 hover:text-white text-3xl transition-colors"
                  onClick={() => setShowSubscriptionModal(false)}
                >
                  ×
                </button>
              </div>
            </div>

            {/* Modal Body */}
            <div className="p-6 text-center">
              {/* Title */}
              <h3 className="text-xl font-bold text-gray-800 mb-2">
                AI Features Require Subscription
              </h3>
              
              {/* Description */}
              <p className="text-gray-600 text-sm mb-6">
                To use AI image generation and other premium features, 
                you need an active subscription. Subscribe through our mobile app to get started!
              </p>

              {/* What You Get */}
              <div className="flex gap-4 rounded-xl flex-row bg-gradient-to-r from-purple-50 to-pink-50">
                <div className="mt-10 p-4 mb-6 text-left">
                  <p className="font-semibold text-gray-700 mb-2 flex items-center gap-2">
                    <span>🎯</span> What you get:
                  </p>
                  <ul className="space-y-2 text-sm text-gray-600">
                    <li className="flex items-center gap-2">
                      <span className="text-green-500">✓</span> AI project creation
                    </li>
                    <li className="flex items-center gap-2">
                      <span className="text-green-500">✓</span> AI image generation
                    </li>
                    <li className="flex items-center gap-2">
                      <span className="text-green-500">✓</span> AI task generation
                    </li>
                    <li className="flex items-center gap-2">
                      <span className="text-green-500">✓</span> Chat with Fern AI (Premium Plan)
                    </li>
                    <li className="flex items-center gap-2">
                      <span className="text-green-500">✓</span> Priority support
                    </li>
                  </ul>
                </div>

                {/* QR Code Section */}
                <div className="mb-6">
                  <p className="text-sm font-semibold text-gray-700 mb-3 mt-4 flex items-center justify-center gap-2">
                    Scan to download the app
                  </p>
                  <div className="flex justify-center">
                    <div className="bg-white p-2 rounded-2xl shadow-lg inline-block">
                      <img 
                        src={qrCode} 
                        alt="Download Fern App" 
                        className="w-48 h-48 object-contain"
                      />
                    </div>
                  </div>
                  <p className="text-xs text-gray-500 mt-3">
                    Available on iOS and Android
                  </p>
                </div>
              </div>

              {/* Alternative Text */}
              <div className="border-t border-gray-100 pt-4">
                <p className="text-xs text-gray-400">
                  Already have a subscription? Make sure you're logged in with the same account.
                </p>
              </div>
            </div>

            {/* Modal Footer */}
            <div className="flex justify-center gap-3 px-6 py-4 bg-gray-50 border-t border-gray-100">
              <button 
                className="px-6 py-2 rounded-lg font-medium text-gray-600 hover:text-gray-800 hover:bg-gray-100 transition-all duration-200"
                onClick={() => setShowSubscriptionModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        @keyframes slideUp {
          from { 
            opacity: 0;
            transform: translateY(30px);
          }
          to { 
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out;
        }
        
        .animate-slideUp {
          animation: slideUp 0.4s ease-out;
        }
      `}</style>
    </>
  );
};

export default AboutFrondDetails;